// extracted by mini-css-extract-plugin
module.exports = {"title":"_-1Z2fR0XGuTbywqmlwYrN","text":"_23Q2LyLLW8G6-JRYuMJGuG","dialogModal":"_13b3OGrVcQeFI6agHns12x","button":"a5WhhwrwOqw3L0ox2QC_L","input":"C_dFPAvSceckh-HbIhf6m"};